
import { UserManager, WebStorageStateStore } from 'oidc-client-ts';
import authConfig from './authConfig';
import AuthorizationService from './helpers/AuthorizationService';

const userManager = new UserManager({
    ...authConfig,
    userStore: new WebStorageStateStore({ store: window.sessionStorage }),
});

export const redirectToLogin = () =>
    async (dispatch) => {
        try{
            await userManager.signinRedirect();
        }
        catch(error) {
            console.error('Error during Login redirect: ', error);
            dispatch({type: 'LOGIN_REDIRECT_ERROR', payload: error})
        }
    }

export const logout = () =>
    async (dispatch) => {
        try{
            AuthorizationService.instance = null;
            userManager.clearStaleState();
            dispatch({type: 'LOGOUT'})
            await userManager.signoutRedirect();
        }
        catch(error) {
            console.error('Error during Logout redirect: ', error);
        }
    }

export const setUser = (user) => 
    async (dispatch) => {
        try{
            dispatch({type: 'SET_USER', payload: user})
        }
        catch(error) {
            console.error('Error during Set User: ', error);
            
        }
    };

export const setLoading = (isLoading) => ({
    type: 'SET_LOADING', payload: isLoading
})